import React from 'react';
import Spinner from '../../components/Spinner';
import makeBodyText from '../../utils/makeText';
import styles from './index.module.scss';
const WaitingOverlay = () => {
    return (React.createElement("div", { className: styles.awaitingOverlay },
        React.createElement("div", { className: styles.container },
            React.createElement(Spinner, { color: 'blue', size: 'L' }),
            React.createElement("p", { className: `${makeBodyText('XL')} ${styles.text}` }, "We\u2019re processing your information. Please do not click the back button or leave/refresh this page."))));
};
export default WaitingOverlay;
